/* ============================================================
   Collection Row — assets/collection-row.js
   Only wires the custom scrollbar. Add-to-cart, the variant
   modal and the cart bar are all handled by the shared
   collection-menu.js (delegated document-level listeners),
   which this section loads alongside it.
   ============================================================ */
(function () {
  'use strict';

  function Scrollbar(grid, track, thumb) {
    if (!grid || !track || !thumb) return;
    var dragging = false;

    function update() {
      var ratio = grid.clientWidth / grid.scrollWidth;
      if (ratio >= 0.999) { track.style.visibility = 'hidden'; return; }
      track.style.visibility = 'visible';
      var w = Math.max(ratio * track.clientWidth, 34);
      thumb.style.width = w + 'px';
      var max = grid.scrollWidth - grid.clientWidth;
      thumb.style.left = (max > 0 ? grid.scrollLeft / max : 0) * (track.clientWidth - w) + 'px';
    }
    function seek(x) {
      var r = track.getBoundingClientRect(), w = thumb.offsetWidth;
      var p = Math.min(Math.max((x - r.left - w / 2) / (r.width - w), 0), 1);
      grid.scrollLeft = p * (grid.scrollWidth - grid.clientWidth);
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    track.addEventListener('pointerdown', function (e) {
      dragging = true; track.setPointerCapture(e.pointerId); seek(e.clientX);
    });
    track.addEventListener('pointermove', function (e) { if (dragging) seek(e.clientX); });
    track.addEventListener('pointerup', function () { dragging = false; });
    track.addEventListener('pointercancel', function () { dragging = false; });
    update();
    setTimeout(update, 200);
  }

  function init(root) {
    if (root.dataset.crowReady === '1') return;
    root.dataset.crowReady = '1';
    var id = root.dataset.sectionId;
    Scrollbar(
      document.getElementById('crow-grid-' + id),
      document.getElementById('crow-track-' + id),
      document.getElementById('crow-thumb-' + id)
    );
  }

  function boot() {
    document.querySelectorAll('.cmenu--single').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.cmenu--single');
    if (root) init(root);
  });
})();
